/**
 * The external dependencies.
 */
import {applyMiddleware, combineReducers, compose, createStore} from 'redux';
import createSagaMiddleware from 'redux-saga';
/**
 * The internal dependencies.
 */
import requestsReducer from '../store/requests/reducer';
import authReducer from '../store/auth/reducer';
import authEffects from '../store/auth/effects';
import tasksReducer from '../store/tasks/reducer';
import tasksEffects from '../store/tasks/effects';
import taskViewReducer from '../store/task-view/reducer';
import taskViewEffects from '../store/task-view/effects'
import qualityReducer from '../store/quality/reducer'
import qualityEffects from '../store/quality/effects'

import dispoReducer from '../store/dispo/reducer'
import dispoEffects from '../store/dispo/effects'

const reducer = combineReducers({
    requests: requestsReducer,
    auth: authReducer,
    tasks: tasksReducer,
    taskView: taskViewReducer,
    quality: qualityReducer,
    dispo: dispoReducer
});

/**
 * Setup the middlewares.
 */
const saga = createSagaMiddleware();
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const enhancer = applyMiddleware(saga);
const store = createStore(reducer, {}, composeEnhancers(
    enhancer
));

saga.run(authEffects);
saga.run(tasksEffects);
saga.run(taskViewEffects);
saga.run(qualityEffects);
saga.run(dispoEffects);

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js